export default __webpack_public_path__ + "static/media/signIn_signUp_bg_maghreb_mobile.a7c7b255.png";